import { Injectable } from '@angular/core';
import { Message } from '@core/models/message.model';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BannerService {
  private messageStack: Message[] = [];
  private messageSubject = new BehaviorSubject<Message>(null);
  private closedSubject = new Subject<string>();

  message$ = this.messageSubject.asObservable();
  closed$ = this.closedSubject.asObservable();

  constructor() { }

  flush(): void {
    this.messageStack = [];
  }

  showMessage(message: Message): void {
    if (this.messageStack.find((msg) => message.name === msg.name)) {
      return;
    }

    this.messageStack.push(message);
    this.messageSubject.next(message);
  }

  hideMessage(name: string): void {
    if (this.messageSubject.value.name === name) {
      this.popMessage();
    }

    this.messageStack = this.messageStack.filter((msg) => msg.name === name);
  }

  closed(): void {
    this.closedSubject.next(this.messageSubject.value.name);
    this.popMessage();
  }

  private popMessage(): void {
    this.messageStack.pop();

    if (this.messageStack.length > 0) {
      this.messageSubject.next(this.messageStack[this.messageStack.length - 1]);
    }
  }
}
